/**
 * PageHeader — consistent H1 block used at the top of every dashboard page.
 *   • Overline eyebrow (e.g., "Retail Dashboard")
 *   • H1 title (, extrabold, tracking-tight)
 *   • Optional subtitle (muted, small)
 *   • Optional right-hand action slot (buttons)
 *
 * Follows the design_guidelines.json typography hierarchy.
 */
export default function PageHeader({ icon: Icon, eyebrow, title, subtitle, actions, testId }) {
    return (
        <div
            className="mb-6 flex items-start justify-between gap-4 flex-wrap"
            data-testid={testId}
        >
            <div className="min-w-0">
                {eyebrow && (
                    <div
                        className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] font-semibold text-primary mb-1"
                        data-testid={testId ? `${testId}-eyebrow` : undefined}
                    >
                        {Icon && <Icon className="w-3.5 h-3.5 shrink-0" strokeWidth={2} />}
                        {eyebrow}
                    </div>
                )}
                <h1 className="font-heading text-h1 leading-tight">
                    {title}
                </h1>
                {subtitle && (
                    <p className="text-sm text-muted-foreground mt-1.5 max-w-2xl">{subtitle}</p>
                )}
            </div>
            {actions && (
                <div className="flex items-center gap-2 shrink-0">{actions}</div>
            )}
        </div>
    );
}
